import React__default from 'react';
import { makeStyles, Breadcrumbs, Link, Typography } from '@material-ui/core';
import PropTypes__default from 'prop-types';
import clsx from 'clsx';

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "& .MuiBreadcrumbs-separator": {
        margin: theme.spacing(0, 1.25)
      },
      "& 	.MuiBreadcrumbs-li a": {
        cursor: "pointer"
      }
    }
  };
});
var Breadcrumb = function Breadcrumb(_ref) {
  var className = _ref.className,
    linkList = _ref.linkList,
    activePageLabel = _ref.activePageLabel,
    component = _ref.component;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Breadcrumbs, {
    className: clsx(className, classes.root)
  }, linkList === null || linkList === void 0 ? void 0 : linkList.map(function (item) {
    return /*#__PURE__*/React__default.createElement(Link, {
      key: item.label,
      href: item.url,
      variant: "body2",
      classes: classes.pointer,
      color: "initial"
    }, item.label);
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle2",
    component: component
  }, activePageLabel));
};
Breadcrumb.propTypes = {
  className: PropTypes__default.string,
  linkList: PropTypes__default.arrayOf(PropTypes__default.shape({
    label: PropTypes__default.string,
    url: PropTypes__default.string
  })),
  activePageLabel: PropTypes__default.string,
  component: PropTypes__default.string
};

export { Breadcrumb as default };
//# sourceMappingURL=Breadcrumb.js.map
